
import { Container, Row } from 'react-bootstrap';
import useReviews from '../hooks/useReviews';
import Review from '../Review/Review';
import './Reviews.css'

const Reviews = () => {
    const [userReviews, setUserReviews] = useReviews()
    return (
        <Container className='my-4'>
            <Row>
                {
                    userReviews.map(review => <Review 
                        key={review.id}
                        review = {review}
                    ></Review>)
                }
            </Row>
        </Container>
    );
};

export default Reviews;